// extracted by mini-css-extract-plugin
export var assigneeBadge = "_n7-0";
export var assigneeDetails = "_n7-1";
export var assigneeInfo = "_n7-2";
export var dropdownContainer = "_n7-4";
export var dropdownImage = "_n7-5";
export var editAssigneeInfo = "_n7-3";
export var editAssigneeModalContainer = "_n7-6";
export var hidden = "_n7-8";
export var input = "_n7-7";